import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UseFormSetValue } from "react-hook-form";
import { apiClient } from "../../utils/api";
import { useAuthStore } from "../../store/authStore";
import { SignUpRequest, SignUpResponse } from "../../types/auth";

interface UseSignUpReturn {
  isLoading: boolean;
  apiError: string;
  signUp: (data: SignUpRequest, setValue: UseFormSetValue<SignUpRequest>) => Promise<void>;
}

const useSignUp = (): UseSignUpReturn => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  
  const { signIn: storeSignIn } = useAuthStore();

  const signUp = async (data: SignUpRequest, setValue: UseFormSetValue<SignUpRequest>) => {
    setIsLoading(true);
    setApiError("");

    try {
      const response = await apiClient.post<SignUpResponse>("/api/v1/auth/signup", data);
      const responseData = response.data;

      if (responseData.status) {
        storeSignIn(
          {
            accessToken: responseData.access_token,
            refreshToken: responseData.refresh_token,
          },
          responseData.data
        );
        
        navigate("/");
      } else {
        if (responseData.error === "record not found") {
          setApiError("회원가입에 실패했습니다. 입력하신 정보를 다시 확인해주세요.");
        } else {
          setApiError(responseData.error || "회원가입에 실패했습니다. 다시 시도해주세요.");
        }
      }
    } catch (err: any) {
      console.error("회원가입 오류:", err);
      if (err.response?.data?.error) {
        setApiError(err.response.data.error);
      } else {
        setApiError("네트워크 오류가 발생했습니다. 다시 시도해주세요.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    apiError,
    signUp,
  };
};

export default useSignUp; 